import { Box, Grid } from '@mui/material';
import { AdminError, ErrorRateDataPoint, ErrorDistribution } from '../../../types/admin';
import RefreshButton from './shared/RefreshButton';
import ErrorRateChart from './error-tracking/ErrorRateChart';
import ErrorDistributionPie from './error-tracking/ErrorDistributionPie';
import ErrorLogTable from './error-tracking/ErrorLogTable';

interface ErrorTrackingTabProps {
  errors: AdminError[];
  errorRateHistory: ErrorRateDataPoint[];
  errorDistribution: ErrorDistribution[];
  loading?: boolean;
  lastUpdated: string;
  onRefresh: () => void;
  onResolveError: (errorId: string) => Promise<{ success: boolean }>;
}

export default function ErrorTrackingTab({
  errors,
  errorRateHistory,
  errorDistribution,
  loading,
  lastUpdated,
  onRefresh,
  onResolveError,
}: ErrorTrackingTabProps) {
  return (
    <Box>
      {/* Header with Refresh Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <RefreshButton onRefresh={onRefresh} lastUpdated={lastUpdated} loading={loading} />
      </Box>

      {/* Charts */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} lg={8}>
          <ErrorRateChart data={errorRateHistory} loading={loading} />
        </Grid>
        <Grid item xs={12} lg={4}>
          <ErrorDistributionPie data={errorDistribution} loading={loading} />
        </Grid>
      </Grid>

      {/* Error Log Table */}
      <ErrorLogTable errors={errors} loading={loading} onResolve={onResolveError} />
    </Box>
  );
}
